
import React, { Component } from 'react';
import authService from '../api-authorization/AuthorizeService'
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import ListGroup from 'react-bootstrap/ListGroup'
import * as MySound from '../MySound';
import ListGroupItem from 'react-bootstrap/esm/ListGroupItem';
import { MyContext, MyGlobal, MyHeading, MyAlert } from '../GlobalContext';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Alert from 'react-bootstrap/Alert'
import Badge from 'react-bootstrap/Badge'
import 'react-bootstrap-icons';
import { Link } from "react-router-dom";
import FormControl from 'react-bootstrap/FormControl';

export class ChoosePick extends Component {
    static displayName = ChoosePick.name;

    constructor(props) {
        super(props);
        this.state = {
            loadingCLientPicks: false, filteredActiveClients: [], activeClientPicks: [], alertMessage: "", scanPickBarcode: "", scanMessage:""
        };
        this.history = props.history;
    }


    componentDidMount() {
        this.getClientWithActivePicks();
    }

    goto(page, data) {
        this.history.push({
            pathname: page,
            state: data
        });
    }

    render() {
        const handleSearchInput = e => {
            var searchText = e.target.value;
            var filteredItems = this.state.activeClientPicks.filter(function (item) {
                return item.name.toUpperCase().indexOf(searchText.toUpperCase()) > -1;
            });
            this.setState({ filteredActiveClients: filteredItems });
        };
        const handlebarcodeScanKeyPress = e => {
            if (e.keyCode === 13 || e.charCode === 13 || e.which === 13) {
                this.findPick();
            }
        };
        let alertMessage = this.state.alertMessage;
        alertMessage = alertMessage != "" ? <MyAlert variant="danger">{alertMessage}</MyAlert> : "";
        var parent = this;
        return <div >
            <h4>Choose Client with Active Picks</h4>
            <>
                <div>{alertMessage}</div>
                {alertMessage === "" && this.state.activeClientPicks.length === 0 && this.state.loadingCLientPicks === false && <Alert variant="info">There are no active paperless picks.</Alert>}

                {this.state.loadingCLientPicks && <div className="p1"> <em>Loading clients with active picks ... </em></div>}

                {this.state.activeClientPicks.length > 0 && <div>
                    <Row>
                        <Col md>
                            <label>Scan Pick Number: {this.state.scanMessage.length > 0 && <em className="text-warning">{this.state.scanMessage }</em>}</label>
                            <input autoFocus="autofocus" ref="barcodeScanInput" className="form-control" placeholder="Scan Pick Number"
                                value={this.state.scanPickBarcode}
                                onChange={(e) => {
                                    this.setState({ scanPickBarcode: e.target.value });
                                }}
                                onKeyPress={handlebarcodeScanKeyPress}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col >
                            <button type="button" className="btn btn-success col-12 mb-2 mt-1" onClick={() => { this.findPick() }}>Find</button>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="auto">
                            {this.state.activeClientPicks.length > 0 && "Or choose below clients"}
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            {this.state.activeClientPicks.length > 0 && <div>
                                <input className="filter form-control" onInput={handleSearchInput} type="text" placeholder="Search for..." />
                                <ListGroup >
                                    {this.state.filteredActiveClients.map(function (item) {
                                        var child = parent;
                                        return (<ListGroup.Item key={item.name}>                                           
                                            <Button className="col-12" variant="link" onClick={() => child.gotoClientsActivePicks(item)}>{item.name}<Badge pill bg="info" className="text-white float-right">{item.activePicks.length}</Badge></Button>
                                        </ListGroup.Item>);
                                    })}
                                </ListGroup></div>}
                        </Col>
                    </Row>
                </div>}

            </>
        </div >
    }

    gotoClientsActivePicks(item) {
        
        this.logIntoTimeSheet(item.nameCode);
        this.goto('ActivePicks', { activePicks: item });
    }

    getClientWithActivePicks() {
        this.setState({ loadingCLientPicks: true });
        fetch(`api/PaperlessPicking/GetAllActivePicks?warehouseId=${MyGlobal.warehouse}`)
            .then(async response => {
                const isJson = response.headers.get('content-type')?.includes('application/json');
                const result = isJson ? await response.json() : null;
                // check for error response
                if (!response.ok) {
                    const errorText = await response.text();
                    this.setState({ loadingCLientPicks: false, alertMessage: errorText, loading: false });
                    MySound.play(MySound.Sound.stop);
                }
                else {
                    if (result.success) {
                        this.setState({ loadingCLientPicks: false, activeClientPicks: result.data, filteredActiveClients: result.data, alertMessage: "" });
                        if (this.state.activeClientPicks.length > 0) {
                            this.refs.barcodeScanInput.focus();
                        }
                    }
                    else {
                        this.setState({ loadingCLientPicks: false, alertMessage: result.errorMessage, loading: false  });
                        MySound.play(MySound.Sound.stop);
                    }

                }
            })
            .catch(error => {
                this.setState({ loadingCLientPicks: false, alertMessage: error, loading: false  });
                MySound.play(MySound.Sound.stop);
            });
    }

    findPick() {
        var searchText = this.state.scanPickBarcode;
        var scannedPick = null;
        this.state.activeClientPicks.filter(function (item) {
            item.activePicks.filter(function (pick) {
                if (parseInt(searchText) === pick.pickNumber) {
                    scannedPick = pick;
                }
            });
        });

        if (scannedPick !== null) {
            this.logIntoTimeSheet(scannedPick.nameCode);
            MySound.play(MySound.Sound.next);
            this.goto('MHEWithPickRows', { selectedPick: scannedPick });
        }
        else {
            this.setState({ scanMessage: "Invaid Pick Number."});
        }
    }

    async logIntoTimeSheet(nameCode) {
        let userID = MyGlobal.user;
        this.setState({ loading: true, locationVeficationMsg: "" });
        const logIntoTimeSheetRequest = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ UserId: userID, nameCode: nameCode })
        };
        fetch('api/PaperlessPicking/LogIntoTimesheet', logIntoTimeSheetRequest) //
            .then(async response => {
                const isJson = response.headers.get('content-type')?.includes('application/json');
                const result = isJson ? await response.json() : null;
                // check for error response
                if (!response.ok) {
                    const errorText = await response.text();
                    var errorDetail = JSON.parse(errorText);
                    var error = JSON.stringify(errorDetail.errors);
                    this.setState({ alertMessage: error, loading: false });
                }
                else {
                    if (result.success) {
                        this.setState({ loading: false, alertMessage: "", });
                    }
                    else {
                        this.setState({ loading: false, alertMessage: result.errorMessage });
                    }
                }
            })
            .catch(error => {
                this.setState({ loading: false, alertMessage: error });
            });
    }
}
